module.exports = __webpack_public_path__ + "img/quizzort_handle.caba1805.png";